import { useTranslation } from 'react-i18next';

import { OpText } from 'new-components/DLS/OpText/OpText';
import { OpButton } from 'new-components/DLS/OpButton/OpButton';
import avigilonAltaLogo from 'assets/img/avigilon-alta-logo-light.svg';
import { useLogout } from 'utils/customHooks/useLogout';
import { OpSpace } from 'new-components/DLS/OpSpace/OpSpace';

import './OpAccessDenied.scss';

export const OpAccessDenied = () => {
  const { t } = useTranslation();
  const { logout } = useLogout();

  const heading = t('Please log out now.');
  const subheading = t('Then login with the correct account.');
  return (
    <div className="op-access-denied" data-testid="op-access-denied">
      <OpText fontWeight="500" className="op-access-denied__heading">
        {heading}
      </OpText>
      <OpText fontWeight="500" className="op-access-denied__subheading">
        {subheading}
      </OpText>
      <OpSpace orientation="vertical">
        <OpButton
          type="primary"
          className="op-access-denied__logout-button"
          onClick={logout}
        >
          {t('Logout')}
        </OpButton>
      </OpSpace>
      <img
        className="op-access-denied__alta-logo"
        src={avigilonAltaLogo}
        alt="Logo"
      />
    </div>
  );
};
